export default "__VITE_ASSET__wECFf2_I__"